import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createTopic, CreateTopicParams} from '../api';
import {QUERY__TOPICS} from '../queryKeys';

export const useCreateTopic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateTopicParams) => createTopic(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__TOPICS],
      });
    },
  });
};
